<template>
	<section>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery
				v-if="isQuery"
				class="margin-layout"
				:formdata="getBase"
				:value="formData"
				placeholder="--"
			></compFormQuery>
			<compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
		</compWrapper>
        <compWrapper
			:title="$t('',{defaultValue:'单据明细'})"
			theme="primary"
		>
			<vTable class="margin-15" :columns="getProductColumns" :data="productList" border></vTable>
		</compWrapper>
        <compPhotoLog v-if="isQuery" v-bind="photoData"></compPhotoLog>
        <div class="text-right margin-right-15">
            <vButton
                class="margin-left-10"
                v-for="item in getStatusBtns"
                :key="item.name"
                @click="item.run"
                :theme="item.theme"
            >{{item.name}}</vButton>
        </div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="back"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
		
	</section>
</template>
<script>
import {HttpUnsourcedInbound
} from '@/service/inbound';

import { mapGetters } from 'vuex';
import mixin from "./mixin";
export default {
    mixins: [mixin],
	props: ['activeid','querytype'],
    data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
            id:  this.activeid || this.$route.query.id,
			showModal: false,
			formData: {
			},
			productList: [],//入库计划单明细,
			logList: [],//log,
			warehouseList: [],
			modalProps: {
				show: false,
				// title: '导入数据',
				// component: "",
				// props: {},
				// on: {},
			},
            photoData: {}
        };
    },
    created() {
		this.getDetail();
		
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getFilterDisabledWarehouse','getBillcusorgList']),

		isQuery() {
			return this.type === 'query'
		},
        getStatusBtns() {
			const btn = [ {
				name: this.$t('global.common.return', { defaultValue: '返回' }),
				show: true,
				theme: 'info',
				run: this.back
			}

			]

			return btn.filter(item => item.show);
        },

        getBase() {
			return [{
				label: this.$t('', { defaultValue: '入库单号' }),
				key: "unsourcedInboundOrderNo",
			},{
			    label: this.$t('', { defaultValue: '入库仓库' }),
                key: 'orgWarehouseCode'
			},{
				label: this.$t('', { defaultValue: '接收类型' }),
				key: "orderType",
				tag: "vSelect",
				options: this.getOrderType
			},{
			    label: this.$t('', { defaultValue: '来源单号' }),
                key: 'sourceNo'
			},{
				label: this.$t('', { defaultValue: '项目' }),
				tag: "vSelect",
				key: "lineId",
				options: this.getProductList
			},
			{
				label: this.$t('global.common.status', { defaultValue: '状态' }),
				tag: "vSelect",
				key: "unsourcedInboundOrderStatus",
				options: this.getStatus
			},
			{
				label: this.$t('', { defaultValue: '物流单号' }),
				key: "trackingNo",
			},{
				label: this.$t('', { defaultValue: '参考号' }),
				key: "refNo",
			},{
				label: this.$t('', { defaultValue: '入库时间' }),
				key: "stockinAt",
			},{
				label: this.$t('', { defaultValue: '托盘数' }),
				key: "palletQty",
			},{
				label: this.$t('', { defaultValue: '箱数' }),
				key: "cartonQty",
			},
			{
				label: this.$t('global.common.notes', { defaultValue: '备注' }),
				tag: "vTextarea",
				key: "remark",
			},
			];
        },
        getProductColumns() {
			return [{
				title: "No.",
				type: 'index'
			},{
				title: "ERP SKU",
				key: 'sku'
			},{
				title: "QTY",
				key: 'qty'
			},{
				title: "库存类型",
				tag: "vSelect",
				key: "inventoryType",
				render: (h, {
                        row
                    }) => this.findRenderLabel(this.getInventoryType, row.inventoryType)
			},{
				title: "备注",
				key: 'remark'
			},{
				title: this.$t('', { defaultValue: '更新时间' }),
				key: 'updatedAt',
			}];
		}
    },
    methods: {
		
		back() {
			this.$emit('on-update')
			
		},
		//获取详情
		getDetail() {
			if (this.isAdd) return;
			this.loading = true;
			if(this.id){
				HttpUnsourcedInbound({ id: this.id }).then(res => {
					this.loading = false;
					const data = res.data;
					this.productList = data.unsourcedInboundOrderItemEntities || [];
					this.formData = data;
                    this.photoData.orderData = this.formData;
                    this.photoData.orderType = 9; 
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
			}
			
		},

    },
    

}
</script>